<template>
    <!--section--> 
    <section id="sec1" class="scroll-con-sec" v-if="showSection">
        <div class="container">
            <div class="section-title fl-wrap">
                <div class="sec-title_dec"></div>
            </div>
            <div class="row">
                <div class="col-md-5">
                    <div class="about-img fl-wrap">
                        <img :src="image" class="respimg" alt="About">
                    </div>
                </div>
                <div class="col-md-7" v-html="content"></div>
            </div>
            
            <div class="inline-facts-container fl-wrap" v-if="stats.length">
                <div class="inline-facts-wrap" v-for="stat in stats" :key="stat.label">
                    <div class="inline-facts">
                        <div class="milestone-counter">
                            <div class="stats animaper">
                                <div class="num" :data-content="0" :data-num="stat.value">0</div>
                            </div>
                        </div>
                        <h6>{{ stat.label }}</h6>
                    </div>
                </div> 
            </div>
        </div>
        <div class="section-number">
            <span>0</span>1<strong>.</strong>
        </div>
    </section>
    <!--section end-->
</template>

<script>
export default {
    name: 'AboutSection',
    data() {
        return {
            showSection: true,
            content: '',
            image: '',
            stats: [
            ]
        }
    },
    async mounted() {
        await this.loadAboutSettings()
        
        // Initialize counter animation after stats are loaded
        this.$nextTick(() => {
            setTimeout(() => {
                this.initCounterAnimation()
            }, 100)
        })
    },
    beforeUnmount() {
        // Clean up appear plugin
        const $ = window.jQuery
        if ($ && $.fn.appear) {
            $(".stats").off('appear')
        }
    },
    methods: {
        async loadAboutSettings() {
            try {
                const response = await this.$api.get('public/pages/about-us')
                if (response.data) {
                    const homeData = response.data.data

                    this.content = homeData.content
                    this.image = homeData.banner_image
                    
                    if (homeData.page_items) {
                        this.stats = homeData.page_items.map(item => ({
                            label: item.title,
                            value: item.content.replace(/<[^>]*>?/g, '')
                        }))
                    }
                    
                    console.log('✅ Loaded about section with', this.stats.length, 'stats')
                }
            } catch (error) {
                console.error('❌ Failed to load about content:', error)
            }
        },
        
        initCounterAnimation() {
            const $ = window.jQuery
            
            if (!$ || !$.fn.appear || !$.fn.countTo) {
                console.warn('⚠️ jQuery appear or countTo plugin not loaded')
                return
            }
            
            // Initialize counter animation when stats section appears in viewport
            $(".stats").appear(function () {
                $(".num").countTo()
            })
            
            console.log('✅ Counter animation initialized')
        }
    }
}
</script>
